import React, { Component } from 'react';
import { ListCompetitionTeams, CreateTC, GetTC } from './graphql.js';
import TechnicalControlsComponent from '../../../common/components/TechnicalControls';
import { updateInPath } from '../../../../common/utils';
import { getList, getItem, setItem } from '../../../common/utils';
import { clone } from 'ramda';


// END config
export default class Teams extends Component {
  constructor() {
    super();

    this.state = { data: [], loading: false };
    this.filter = {};
  }

  fetchData = async (filter) => {
    if (filter) {
      this.filter = clone(filter);
    }
    
    this.setState(s => updateInPath(s, 'loading', true));

    const data = await getList('listCompetitionTeams', {
      query: ListCompetitionTeams,
      variables: { filter: (filter || this.filter) }
    });

    this.setState(s => updateInPath(s, 'data', data));
    this.setState(s => updateInPath(s, 'loading', false));
  }


  handleTechnicalControlSave = async (data) => {
    await setItem(CreateTC, data);
    this.fetchData();
  }

  
  handleTechnicalControlGet = async (teamId, competitionId, callback) => {
    return await getItem('getTechnicalControl', {
      query: GetTC,
      variables: {
        competitionId: competitionId,
        teamId: teamId
      }
    });
  };

  render() {
    const { data, loading } = this.state;
    
    return (
      <TechnicalControlsComponent
        data={data}
        refresh={this.fetchData}
        onTechnicalControlView={this.handleTechnicalControlGet}
        onTechnicalControlSave={this.handleTechnicalControlSave}
        loading={loading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/containers/TechnicalControl/index.js